import React from "react";

// Decorative lotus SVG used across pages.
export const LotusMark = ({ className = "w-8 h-8", stroke = "#3E7C6F" }) => (
  <svg
    className={className}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g stroke={stroke} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M32 14c5 6 5 18 0 27-5-9-5-21 0-27z" />
      <path d="M32 41c-6-3-12-9-13-18 7 1 12 6 13 12" />
      <path d="M32 41c6-3 12-9 13-18-7 1-12 6-13 12" />
      <path d="M32 41c-9 0-17-3-22-10 8-3 17-1 22 4" />
      <path d="M32 41c9 0 17-3 22-10-8-3-17-1-22 4" />
      <path d="M14 46c4 2 8 3 18 3s14-1 18-3" />
    </g>
  </svg>
);

// Full logo using the actual logo image. Used in header and footer.
export const Logo = ({ light = false, compact = false }) => {
  return (
    <span className="flex items-center gap-2.5 group">
      <img
        src="/logo.png"
        alt="Yogarambh Wellness"
        className={`object-contain transition-transform duration-500 group-hover:scale-105 ${
          compact ? "h-8 w-auto" : "h-14 w-auto"
        } ${light ? "brightness-0 invert" : ""}`}
      />
    </span>
  );
};

export default Logo;
